import React, { useState, useEffect } from "react";
import AddDepartmentModal from "./AddDepartment";
import { Department, DepartmentFormData } from "../../interfaces/departments";
import { getDepartments, getDepartmentById } from "../../apis/departments";
import MastersBreadcrumb from "../../components/MastersBreadcrumb";

const DepartmentsList: React.FC = () => {
  const [departments, setDepartments] = useState<Department[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const [editableId, setEditableId] = useState<number | null>(null);
  const [selectedDepartment, setSelectedDepartment] =
  useState<DepartmentFormData | null>(null);

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const res: any = await getDepartments();
      setDepartments(res.data || res);
    } catch (error) {
      console.log("Error fetching departments:", error);
    }
  };
  const handleAddDepartment = () => {
    fetchDepartments();
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <MastersBreadcrumb current="Departments" />
      <div className="sm:flex sm:items-center sm:justify-between">
        <div>
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Departments List
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            List of all departments.
          </p>
        </div>

        <button
          type="button"
          onClick={() => setOpenModal(true)}
          className="px-3 py-2 text-sm font-semibold text-white rounded-md shadow-sm bg-primary hover:bg-hover"
        >
          Add Department
        </button>
      </div>

      <AddDepartmentModal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setEditableId(null);
          setSelectedDepartment(null);
        }}
        onSuccess={handleAddDepartment}
        editableId={editableId}
        departmentData={selectedDepartment}
      />

      <div className="flow-root mt-8">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      Name
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {departments.length === 0 ? (
                    <tr>
                      <td colSpan={4} className="py-4 text-center text-sm text-gray-500">
                        No departments found
                      </td>
                    </tr>
                  ) : (
                    departments.map((dept) => (
                      <tr key={dept.id}>
                        <td className="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                          {dept.name}
                        </td>
                        <td className="py-4 px-3 text-sm text-gray-700">
                          <button
                            onClick={async () => {
                              try {
                                const res: any = await getDepartmentById(dept.id);
                                const data = res.data || res;
                                setEditableId(dept.id);
                                setSelectedDepartment({
                                  name: data.name,
                                  code: data.code,
                                  businessUnitId: data.businessUnitId ?? data.business_unit_id ?? null,
                                  isPharmacyBusinessUnit:
                                    !!(data.isPharmacyBusinessUnit ?? data.is_pharmacy_business_unit),
                                  isLabBusinessUnit:
                                    !!(data.isLabBusinessUnit ?? data.is_lab_business_unit),
                                });
                                setOpenModal(true);
                              } catch (error) {
                                console.log("Error fetching department:", error);
                              }
                            }}
                            className="px-3 py-2 text-sm text-white bg-primary rounded"
                          >
                            Edit
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepartmentsList;
